import { Trans } from '@lingui/macro';
import React from 'react';
import { useDispatch } from 'react-redux';

import { closeModal } from '../../../../../index';
import {
    TeacherAdminIcon, Button
} from '@components';

export type NotificationPropsType = {
    summary: string
    title: string
};

export function Notification (props: NotificationPropsType) {
    const dispatch = useDispatch();

    return (
        <>
            <TeacherAdminIcon icon={'warning'} width={35} />
            <h3>{ props.title }</h3>
            <p>{ props.summary }</p>
            <Button onClick={() => dispatch(closeModal())}>
                <Trans id={'button.ok'} />
            </Button>
        </>
    );
}
